import React, { useState, useEffect } from 'react';
import './Preferences.scss';

const Configurations = () => {
  const [fontSize, setFontSize] = useState(10);
  
  useEffect(() => {
    document.body.style.fontSize = `${fontSize}px`;
  }, [fontSize]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const root = document.getElementById('root');
    root.classList.add('force-dark');
    return () => {
      root.classList.remove('force-dark');
    };
  }, []);

  return (
    <div className='page preferences'>
      <div className='container'>
        <span className='title'>Preferencias</span>
        <section className='wrapper font-size'>
          <span className='wrapper__title'>
            Tamaño de la fuente
          </span>
          <div className='wrapper__content'>
            <button
              className='minus'
              onClick={() => fontSize >= 11 ? setFontSize(fontSize - 2) : null}
            >
              -
            </button>
            <span>
              A b c
            </span>
            <button
              className='plus'
              onClick={() => fontSize <= 14 ? setFontSize(fontSize + 2) : null}
            >
            +
            </button>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Configurations;